import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b4d0222"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Get recommendations for...", -1))
const _hoisted_3 = { class: "form-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "trackingId" }, "Tracking Id", -1))
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customerId" }, "Customer Id (Guid)", -1))
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "postcode" }, "Postcode", -1))
const _hoisted_9 = { class: "form-item geo" }
const _hoisted_10 = { class: "manual-geo" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "latitude" }, "Latitude", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "longitude" }, "Longitude", -1))
const _hoisted_13 = { class: "preset-geos" }
const _hoisted_14 = { for: "presetgeo-darwin" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Darwin")
const _hoisted_16 = { for: "presetgeo-brisbane" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Brisbane")
const _hoisted_18 = { for: "presetgeo-perth" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Perth")
const _hoisted_20 = { for: "presetgeo-sydney" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Sydney")
const _hoisted_22 = { for: "presetgeo-melbourne" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Melbourne")
const _hoisted_24 = { for: "presetgeo-hobart" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Hobart")
const _hoisted_26 = { class: "form-item location-type" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Use:", -1))
const _hoisted_28 = { for: "usenone" }
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" None")
const _hoisted_31 = { for: "usepostcode" }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Postcode")
const _hoisted_34 = { for: "usegeo" }
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Geo")
const _hoisted_37 = {
  key: 0,
  class: "container loading"
}
const _hoisted_38 = {
  key: 1,
  class: "container report"
}
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<h1 data-v-1b4d0222>Report</h1><ol data-v-1b4d0222><li data-v-1b4d0222><a href=\"#configuration-used\" data-v-1b4d0222>Configuration used</a></li><li data-v-1b4d0222><a href=\"#customer-details\" data-v-1b4d0222>Customer details</a></li><li data-v-1b4d0222><a href=\"#summary\" data-v-1b4d0222>Summary</a></li><li data-v-1b4d0222><a href=\"#event-statistics\" data-v-1b4d0222>Event statistics</a></li><li data-v-1b4d0222><a href=\"#sections\" data-v-1b4d0222>Sections</a></li></ol><h2 id=\"configuration-used\" data-v-1b4d0222>Configuration used</h2>", 3)
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Key"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Value")
  ])
], -1))
const _hoisted_43 = { "data-type": "text" }
const _hoisted_44 = { "data-type": "text" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "customer-details" }, "Customer details", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Key"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Value")
  ])
], -1))
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { "data-type": "text" }
const _hoisted_49 = { "data-type": "text" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "No user data")
], -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Customer recommended events ")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "EventKey"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Venue"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Categories"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "number" }, "Score")
  ])
], -1))
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { "data-type": "text" }
const _hoisted_59 = { "data-type": "text" }
const _hoisted_60 = { "data-type": "text" }
const _hoisted_61 = { "date-type": "text" }
const _hoisted_62 = { "date-type": "text" }
const _hoisted_63 = { "data-type": "number" }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, "No user data")
], -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "summary" }, "Summary", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Section Title"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Section Id"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "number" }, "Events"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "number" }, "Top score")
  ])
], -1))
const _hoisted_69 = { "data-type": "text" }
const _hoisted_70 = { "data-type": "text" }
const _hoisted_71 = { "data-type": "number" }
const _hoisted_72 = { "data-type": "number" }
const _hoisted_73 = { id: "event-statistics" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Event statistics ")
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { "data-type": "number" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Top recurring events"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Event name"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Sections: Order")
  ])
], -1))
const _hoisted_76 = { "data-type": "number" }
const _hoisted_77 = { "data-type": "text" }
const _hoisted_78 = { "data-type": "text" }
const _hoisted_79 = { "data-type": "text" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "sections" }, "Sections", -1))
const _hoisted_81 = ["onClick"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "EventKey"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Venue"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "text" }, "Categories"),
    /*#__PURE__*/_createElementVNode("th", { "data-type": "number" }, "Score (% of top score)")
  ])
], -1))
const _hoisted_83 = { "data-type": "text" }
const _hoisted_84 = { "data-type": "text" }
const _hoisted_85 = { "data-type": "text" }
const _hoisted_86 = { "data-type": "text" }
const _hoisted_87 = { "data-type": "text" }
const _hoisted_88 = { "data-type": "number" }
const _hoisted_89 = { class: "percent-viz" }
const _hoisted_90 = { class: "percent-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "container form",
      onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      (!_ctx.hasDeveloperCookie)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " !! You haven't set you developer cookie... make sure you set it and refresh the page, if you want to override Tracking ID. "))
        : _createCommentVNode("", true),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "trackingId",
          name: "trackingId",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.trackingId) = $event)),
          autocomplete: "off"
        }, null, 512), [
          [_vModelText, _ctx.form.trackingId]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "customerId",
          name: "customerId",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.customerId) = $event)),
          autocomplete: "off"
        }, null, 512), [
          [_vModelText, _ctx.form.customerId]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "postcode",
          name: "postcode",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.postcode) = $event)),
          autocomplete: "off"
        }, null, 512), [
          [_vModelText, _ctx.form.postcode]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "latitude",
            name: "latitude",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.latitude) = $event)),
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, _ctx.form.latitude]
          ]),
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "longitude",
            name: "longitude",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.longitude) = $event)),
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, _ctx.form.longitude]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "presetgeo-darwin",
              name: "presetgeo",
              value: "-12.462827,130.841782",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.presetGeo) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.form.presetGeo]
            ]),
            _hoisted_15
          ]),
          _createElementVNode("label", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "presetgeo-brisbane",
              name: "presetgeo",
              value: "-27.47126,153.02385",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.presetGeo) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.form.presetGeo]
            ]),
            _hoisted_17
          ]),
          _createElementVNode("label", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "presetgeo-perth",
              name: "presetgeo",
              value: "-31.95264,115.85741",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.presetGeo) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.form.presetGeo]
            ]),
            _hoisted_19
          ]),
          _createElementVNode("label", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "presetgeo-sydney",
              name: "presetgeo",
              value: "-33.8696,151.20695",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.presetGeo) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.form.presetGeo]
            ]),
            _hoisted_21
          ]),
          _createElementVNode("label", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "presetgeo-melbourne",
              name: "presetgeo",
              value: "-37.81753,144.96715",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.presetGeo) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.form.presetGeo]
            ]),
            _hoisted_23
          ]),
          _createElementVNode("label", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "presetgeo-hobart",
              name: "presetgeo",
              value: "-42.88164,147.33162",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.presetGeo) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.form.presetGeo]
            ]),
            _hoisted_25
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "usenone",
              value: _ctx.locationType.None,
              name: "use",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.use) = $event))
            }, null, 8, _hoisted_29), [
              [_vModelRadio, _ctx.form.use]
            ]),
            _hoisted_30
          ]),
          _createElementVNode("label", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "usepostcode",
              value: _ctx.locationType.Postcode,
              name: "use",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.use) = $event))
            }, null, 8, _hoisted_32), [
              [_vModelRadio, _ctx.form.use]
            ]),
            _hoisted_33
          ]),
          _createElementVNode("label", _hoisted_34, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "usegeo",
              value: _ctx.locationType.Geo,
              name: "use",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.use) = $event))
            }, null, 8, _hoisted_35), [
              [_vModelRadio, _ctx.form.use]
            ]),
            _hoisted_36
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("input", {
          type: "submit",
          value: "Get recommendations",
          onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        })
      ])
    ], 32),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createVNode(_component_loading)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.report.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("table", null, [
            _hoisted_42,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.report.options), (optionKey) => {
                return (_openBlock(), _createElementBlock("tr", { key: optionKey }, [
                  _createElementVNode("td", _hoisted_43, _toDisplayString(optionKey), 1),
                  _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.report.options[optionKey]) + _toDisplayString(optionKey == "use" ? " (0 = Postcode, 1 = Geo, 2 = None)" : ""), 1)
                ]))
              }), 128))
            ])
          ]),
          _hoisted_45,
          _createElementVNode("table", null, [
            _hoisted_46,
            (_ctx.userProfile)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.userProfile), (optionKey) => {
                    return (_openBlock(), _createElementBlock("tr", { key: optionKey }, [
                      _createElementVNode("td", _hoisted_48, _toDisplayString(optionKey), 1),
                      _createElementVNode("td", _hoisted_49, [
                        (optionKey == 'recommendedEvents')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, "See \"Customer recommended events\" table below"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.userProfile[optionKey]), 1))
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_52, _hoisted_54))
          ]),
          _createElementVNode("h3", null, [
            _hoisted_55,
            _createElementVNode("button", {
              onClick: _cache[16] || (_cache[16] = 
          () => {
            _ctx.showCustomerEventsTable = !_ctx.showCustomerEventsTable;
          }
        )
            }, _toDisplayString(_ctx.showCustomerEventsTable ? "Hide" : "Show"), 1)
          ]),
          _withDirectives(_createElementVNode("table", null, [
            _hoisted_56,
            (_ctx.userProfile)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_57, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userProfile.recommendedEvents, (event, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", _hoisted_58, _toDisplayString(i + 1), 1),
                      _createElementVNode("td", _hoisted_59, _toDisplayString(event.eventKey), 1),
                      _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.recommendations.catalog.find(e => e.eventKey == event.eventKey)
                ?.eventName || "--"), 1),
                      _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.recommendations.catalog.find(e => e.eventKey == event.eventKey)
                ?.venue.name || "--") + ", " + _toDisplayString(_ctx.recommendations.catalog.find(e => e.eventKey == event.eventKey)
                ?.venue.locality || "--") + " ( " + _toDisplayString(_ctx.recommendations.catalog.find(e => e.eventKey == event.eventKey)
                ?.venue.state || "--") + " ) ", 1),
                      _createElementVNode("td", _hoisted_62, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendations.catalog.find(
                e => e.eventKey == event.eventKey
              )?.categories, (cat) => {
                          return (_openBlock(), _createElementBlock("span", { key: cat }, _toDisplayString(cat) + ", ", 1))
                        }), 128))
                      ]),
                      _createElementVNode("td", _hoisted_63, [
                        _createElementVNode("code", null, _toDisplayString(event.score.toFixed(4)), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_64, _hoisted_66))
          ], 512), [
            [_vShow, _ctx.showCustomerEventsTable]
          ]),
          _hoisted_67,
          _createElementVNode("table", null, [
            _hoisted_68,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.summary.sections, (section, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", _hoisted_69, _toDisplayString(section.title), 1),
                  _createElementVNode("td", _hoisted_70, _toDisplayString(section.id), 1),
                  _createElementVNode("td", _hoisted_71, _toDisplayString(section.eventCount), 1),
                  _createElementVNode("td", _hoisted_72, [
                    _createElementVNode("code", null, _toDisplayString(section.maxScore.toFixed(2)), 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("h2", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("button", {
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleEventStatisticsTable && _ctx.toggleEventStatisticsTable(...args)))
            }, _toDisplayString(_ctx.showEventStatisticsTable ? "Hide" : "Show"), 1)
          ]),
          _withDirectives(_createElementVNode("table", null, [
            _hoisted_75,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topRecurringEvents, (event, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: event.eventKey
                }, [
                  _createElementVNode("td", _hoisted_76, _toDisplayString(i + 1), 1),
                  _createElementVNode("td", _hoisted_77, _toDisplayString(event.eventKey), 1),
                  _createElementVNode("td", _hoisted_78, _toDisplayString(event.eventName), 1),
                  _createElementVNode("td", _hoisted_79, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.appearances, (appearance, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(appearance.section) + ": " + _toDisplayString(appearance.order), 1))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ], 512), [
            [_vShow, _ctx.showEventStatisticsTable]
          ]),
          _hoisted_80,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fullyHydratedSections, (section, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              _createElementVNode("h3", null, [
                _createTextVNode(_toDisplayString(section.sectionName) + " ", 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.toggleShowEventsTable(i))
                }, _toDisplayString(_ctx.showEventsTable[i] ? "Hide" : "Show"), 9, _hoisted_81)
              ]),
              _withDirectives(_createElementVNode("table", null, [
                _hoisted_82,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.events, (event, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", _hoisted_83, _toDisplayString(i + 1), 1),
                      _createElementVNode("td", _hoisted_84, _toDisplayString(event.eventKey), 1),
                      _createElementVNode("td", _hoisted_85, _toDisplayString(event.eventName), 1),
                      _createElementVNode("td", _hoisted_86, _toDisplayString(event.eventVenue), 1),
                      _createElementVNode("td", _hoisted_87, _toDisplayString(event.eventCategories), 1),
                      _createElementVNode("td", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("span", _hoisted_90, _toDisplayString(((event.eventScore / _ctx.maxScore) * 100).toFixed(2)) + "%", 1),
                          _createElementVNode("span", {
                            class: "percent-indicator",
                            style: _normalizeStyle(`width: ${(event.eventScore / _ctx.maxScore) * 100}%`)
                          }, null, 4)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ], 512), [
                [_vShow, _ctx.showEventsTable[i]]
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}